import { Notify } from "@flexisaf/flexibull2/build/notify";
import { call, put, takeLatest } from "redux-saga/effects";
import { postEdit } from "../../../services/exam";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { editExamStart, editExamSuccess, editExamFailure } from "../reducer";

export function* editExam({ payload }) {
  const { data, callback } = payload;

  const response = yield call(postEdit, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(editExamSuccess());
    Notify("Exam edited successfully", { status: "success" });
    if (callback) {
      callback();
    }
  } else {
    yield put(editExamFailure(message || raw?.error));
    // Notify(message || raw?.error, { status: "error" });
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onEditExam() {
  yield takeLatest(editExamStart.type, editExam);
}
